import { Background, BadgeDescription, BadgeRow, BadgeTitle, Container, ScreenTitle, Wrapper } from './RewardScreen.styled';
import { DisableScroll, EnableScroll } from '@utils/scrollController';
import { useEffect, useRef, useState } from 'react';
import Badge from './Badge';
import BGIn from 'src/lotties/bgIn.json';
import Lottie from 'react-lottie-player';
import { useI18n } from '@i18n/useI18n';
import { breakpoints } from '@styles/tokens';
import Modal from '@components/Buttons/Modal';
import Badges from '@models/Badges';

const AnimationBGIn = {
  loop: true,
  animationData: BGIn,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface IProps {
  type: number;
  screenTitle: string;
  badge?: any;
  closeScreen?: (closeScreen: boolean) => void;
}

const RewardScreen = (props: IProps) => {
  const [start, setStart] = useState(false);
  const [mobile, setMobile] = useState(null);
  const i18n = useI18n();
  const ref = useRef(null)

  useEffect(() => {
    setStart(true);
    return () => {
    };
  }, []);

  const OnCloseScreen = () => {
    setStart(false);
    ref.current?.handleClose();
  };

  const isMobile = () => {
    let m = window.innerWidth <= breakpoints.tablet;
    if (m !== mobile) setMobile(m);
  };

  useEffect(() => {
    window.addEventListener('resize', isMobile);

    isMobile();

    return () => {
      window.removeEventListener('resize', isMobile);
    };
  }, [props.badge]);

  const SetBadges = () => {
    let badges = [];
    if (props.type === 1) {
      badges.push(
        <Badge
          lottie={props.badge.lottie}
          badge={props.badge}
          reward={true}
          enabled={true}
          stage={props.badge.stage}
        />,
      );
    } else {
      for (let i = 0; i < props.badge.levels; i++) {
        if (mobile) {
          if (props.badge.stage === i + 1)
            badges.push(
              <Badge
                lottie={props.badge.lottie}
                key={'badges_' + i}
                badge={props.badge}
                enabled={props.badge.stage > i}
                stages={i + 1}
                stage={props.badge.stage}
              />,
            );
        } else {
          badges.push(
            <Badge
              lottie={props.badge.lottie}
              key={'badges_' + i}
              badge={props.badge}
              enabled={props.badge.stage > i}
              stages={i + 1}
              stage={props.badge.stage}
            />,
          );
        }
      }
    }
    return badges;
  };

   const SelectBadgeIcon = (badgeId:Number) => {
      switch (badgeId) {
        case 1:
          return <Badges.welcome />
        case 2:
          return <Badges.friday_the_13 />
        case 3:
          return <Badges.may_the_4 />
        case 4:
          return <Badges.perfect_week />
        case 5:
          return <Badges.perfect_month />
        case 6:
          return <Badges.i_hate_mondays />
        case 7:
          return <Badges.thank_god_its_friday />
        case 8:
          return <Badges.comeback_kid />
        case 9:
          return <Badges.halloween />
        case 10:
          return <Badges.Pirate_day />
        case 11:
          return <Badges.april_fool />
        case 12:
          return <Badges.valentines_day />
        case 13:
          return <Badges.saint_patrick_day />
        case 14:
          return <Badges.wednesday_warrior />
      }
  }

  return (
    <Modal ref={ref} onClose={props.closeScreen} animateMiddel={true}>
      <Wrapper onClick={() => OnCloseScreen()} start={start}>
        <Container>
          <BadgeRow>
            {/* <ScreenTitle>{i18n.t(props.screenTitle)}</ScreenTitle> */}
            <BadgeTitle>{i18n.t(props.badge.title)}</BadgeTitle>
          </BadgeRow>
          <BadgeRow col={true}>

            {props.badge.lottie !== null?
              SetBadges()
            :
              SelectBadgeIcon(props.badge?.badge_id)
            }

          </BadgeRow>
          <BadgeRow>
            <BadgeDescription>{i18n.t(props.badge.rewardDecription)}</BadgeDescription>
          </BadgeRow>
        </Container>
        <Background>
            <Lottie {...AnimationBGIn} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
        </Background>
      </Wrapper>
    </Modal>
  );
};

export default RewardScreen;
